const env = require('../../../environment-config.js');

// Note: Seems that library code assumes NODE_ENV can only be "development" or "production", not "staging" etc, so we have defined our own APP_ENV which can take on more values.
const config = (() => {
    const app_env = process.env.APP_ENV || 'development';
    const config = env[app_env];
    if (typeof(config) === "undefined") throw "No config exists for "+app_env+" in environment-config.js! Check your APP_ENV environment variable!";
    return config;
})();

module.exports = config;


// WEBPACK FOOTER //
// ./src/server/src/config.js